






















// @ts-ignore
import {fieldProps} from '../BZCore/ActiveField'
import PhoneInput from '../../Inputs/PhoneInput.vue'
import Errors from '../errors.vue'
import Vue from 'vue'

export default Vue.extend({
  name: 'PhoneField',
  components: {Errors, PhoneInput},
  props: fieldProps,
  created () {
    if (!this.value && this.defaultValue) {
      this.$emit('input', this.defaultValue)
    }
  },
  watch: {
    defaultValue (newValue, oldValue) {
      if (this.value === oldValue) {
        this.$emit('input', newValue)
      }
    }
  },
  methods: {
    onInput (event: UIEvent) {
      this.$emit('input', event)
    },
    onBlur (event: UIEvent) {
      this.$emit('blur', event)
    }
  },
  computed: {
    currentValue: {
      get (): string {
        return this.value as string
      },
      set () {

      }
    }
  }
})
